// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Select from 'antd/lib/select';
import Spin from 'antd/lib/spin';
// APOLLO
import { graphql, compose } from 'react-apollo';
import clientTagsQuery from 'ApolloClient/Queries/clientTags';
import createClientTag from 'ApolloClient/Mutations/createClientTag';
import ErrorHelpers from '../../../lib/helpers/ErrorHelpers/index';

const { Option } = Select;

// const children = [];
// for (let i = 10; i < 36; i++) {
//   children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
// }

// function handleChange(value) {
//   console.log(`selected ${value}`);
// }

class ClientTagsInput extends React.PureComponent {
  state = {
    value: this.props.value && this.props.value.length > 0 ? this.props.value : [],
    options:
      this.props.clientTagsQuery && this.props.clientTagsQuery.clientTags ? this.props.clientTagsQuery.clientTags : [],
  };

  componentWillReceiveProps(newProps) {
    if (this.props.clientTagsQuery.clientTags !== newProps.clientTagsQuery.clientTags) {
      this.setState({
        options: newProps.clientTagsQuery.clientTags,
      });
    }
  }

  onAddClientTagToDB = async title => {
    let res;
    // ceate variables for mutation
    let variables = {
      title,
    };
    // try to run mutatoin to create new client tag
    try {
      res = await this.props.createClientTag({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    let newValues = [...this.state.value, res.data.createClientTag._id];

    this.setState({
      value: newValues,
      options: [...this.state.options, res.data.createClientTag],
    });

    this.props.onChange(newValues);
  };

  onChange = (newValues, option) => {
    // the new value will be the last item in the array
    let value;
    if (newValues && newValues.length && newValues[newValues.length - 1]) {
      value = newValues[newValues.length - 1].toLowerCase();
    } else {
      return;
    }
    // we want to get an array of tag ids
    let tagIds = this.state.options.map(clientTag => clientTag._id.toLowerCase());
    let tagTitles = this.state.options.map(clientTag => clientTag.title.toLowerCase());
    // if the tagId that was just added is not in the options array, it must be new, so we'll fire a mutation to create it in the DB
    if (!tagTitles.includes(value) && !tagIds.includes(value)) {
      return this.onAddClientTagToDB(value);
    }

    // sometimes when you type a word, and then a comma "," the tokenizer will send up the string you put in,
    // rather than sending an _id. In this case, the value exists and we don't want to fire the mtuation to make a new one,
    // but we don't want the string "title" in the values array we want the _id there. So we do somefilter and stuff to create
    // an array of values like ["fasfa99fd98a7f9", "8f9afd90as8f0"] instead of a mix like ["fasfa99fd98a7f9", "family"] which
    // is what we'd have if we didn't do this logic here
    if (tagTitles.includes(value) && !tagIds.includes(value)) {
      // get the new item by using the value from the form input against our current array of options (an array of objects)
      let filteredItem = this.state.options.filter(clientTag => clientTag.title === value);
      // the newValues array should only have _ids, but in this case it has a string in there for this new value... we want to change that our for the values _id, so we first clean newValues of the string "title"
      let filteredNewItems = newValues.filter(clientTag => clientTag !== value);
      let newFilteredValues = [...filteredNewItems, filteredItem[0]._id];
      this.setState({ value: newFilteredValues });
      this.props.onChange(newFilteredValues);
      return console.log('SPECIAL ATTENTION NEEDED');
    }

    // if the tag already exists in options, we don't need orr want to create a duplicate in the DB, so we just set local state and pass the values up to the parent form component
    this.setState({ value: newValues });
    this.props.onChange(newValues);
  };

  render() {
    const { loading } = this.props.clientTagsQuery;
    if (loading) {
      return null;
    }
    return (
      <Select
        mode="tags"
        style={{ width: '100%' }}
        value={this.state.value}
        size="large"
        tokenSeparators={[',']}
        onChange={this.onChange}
        placeholder="Select tags"
      >
        {this.state.options ? (
          this.state.options.map(item => (
            <Option key={item._id} value={item._id}>
              {item.title}
            </Option>
          ))
        ) : (
          <Option />
        )}
      </Select>
    );
  }
}

export default compose(
  graphql(createClientTag, { name: 'createClientTag' }),
  graphql(clientTagsQuery, { name: 'clientTagsQuery' }),
)(ClientTagsInput);



// WEBPACK FOOTER //
// ./src/components/inputs/ClientTagsInput/index.js